<template>
  <div class="sms-send">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form inline @submit.prevent="query(1)">
          <el-form-item label="关键词查询">
            <el-input v-model="queryParams.subject" clearable placeholder="请输入关键词查询" @change="query(1)" />
          </el-form-item>
          <el-form-item>
            <el-button icon="search" type="primary" @click="query(1)">查询</el-button>
            <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="模板主题" prop="subject" show-overflow-tooltip />
      <el-table-column label="短信签名" prop="signName" show-overflow-tooltip />
      <el-table-column label="模板内容" prop="content" show-overflow-tooltip />
      <el-table-column label="创建时间" prop="createTime" width="180" />
      <el-table-column align="center" label="操作" width="100">
        <template #default="{ row }">
          <el-link type="primary" :underline="false" @click="handleSend(row)">发送</el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 发送弹窗 -->
    <el-dialog
      destroy-on-close
      :model-value="sendModal.visible"
      title="发送短信"
      :width="780"
      @close="sendModal.close()"
    >
      <SendForm ref="sendFormRef" :data="sendModal.data" @success="onSendSuccess" />
      <template #footer>
        <el-button @click="sendModal.close()">取消</el-button>
        <el-button type="primary" @click="sendFormRef.submit()">确认发送</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { querySmsTemplateList } from '@/api/sms'
  import { omit } from 'lodash'
  import { useModal } from '@/hooks/useModal'
  import SendForm from './SendForm.vue'

  const defaultQueryParams = {
    subject: '',
    auditStatus: 'APPROVED',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })
  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query()
  })

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true
    querySmsTemplateList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list = [], total = 0 } = data || {}
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  function handleSend(row) {
    sendModal.open(row)
  }

  const sendModal = useModal()
  const sendFormRef = ref()

  function onSendSuccess() {
    sendModal.close()
    query()
  }
</script>

<style lang="scss" scoped>
  .sms-send {
    padding: 16px;
  }
</style>
